import * as React from "react";
import { ArrowBackIos, ArrowLeft } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import AppNav from "../../Layout/Appbar/Index";
import "./style.css";


export const SettingPage = () => {
  

  const firstItem = [
    {
      name: "Wallets",
      to: "wallets",
    },
    {
      name: "Buy & Sell",
      to: "buysell",
    },
    {
      name: "Earn",
      to: "earn",
    },
    {
      name: "Setting",
      to: "setting",
    },
  ];

  return (
    <div className="">
      <AppNav firstItem={firstItem} />

      <div className="e7">
        <Grid container sx={{ pt: 5 }} className="bodys" space={4}>
          <Grid item xs={12} md={5}>
            <Box display={"flex"} justifyContent={"center"}>
              <Card sx={{ maxWidth: "320px" }}>
                <CardContent
                  sx={{ height: "400px", width: "400px" }}
                >
                <Typography variant="h6" fontWeight={"bold"}>Settings</Typography>
                    
                </CardContent>
              </Card>
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <Box display={"flex"} justifyContent={"center"}>
              <Card sx={{ minWidth: "100%" }}>
                <CardContent sx={{ height: "400px" }}>
                  <Box sx={{ width: "100%", typography: "body1" }}>
                  
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
